
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
/* To load js in all pages */
if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
  }
// Flits(document).on('Flits:Navigation:Loaded', function(event){
//   var settings = event.detail.settings;
//   var obj = 
//     {
//       title: 'Rewards Program',
//       url:'#rewardprogram',
//       target:0,
//       badge: null,
//       icon: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19"><path d="M9.92,19.5a.4.4,0,0,1-.28-.12A.4.4,0,0,1,9.53,19l.56-2.8a.39.39,0,0,1,.11-.2l6.16-6.16a1.19,1.19,0,0,1,1.68,0L19.15,11a1.19,1.19,0,0,1,0,1.68L13,18.82a.39.39,0,0,1-.2.11l-2.8.56H9.92m.92-3-.42,2.1,2.1-.42,6.07-6.07a.4.4,0,0,0,0-.56l-1.12-1.12a.4.4,0,0,0-.56,0ZM12,2.87H10.79v-.4a.4.4,0,0,0-.4-.4H9.17a2,2,0,0,0-3.88,0H4.06a.4.4,0,0,0-.4.4v.4H2.48a2,2,0,0,0-2,2V15.15a2,2,0,0,0,2,2H8a.4.4,0,0,0,0-.79H2.48a1.19,1.19,0,0,1-1.19-1.19V4.85A1.19,1.19,0,0,1,2.48,3.67H3.67v.4A1.19,1.19,0,0,0,4.85,5.25H9.6a1.19,1.19,0,0,0,1.19-1.19v-.4H12a1.19,1.19,0,0,1,1.19,1.19V9.6a.4.4,0,1,0,.79,0V4.85a2,2,0,0,0-2-2M10,4.06a.4.4,0,0,1-.4.4H4.85a.4.4,0,0,1-.4-.4V2.87H5.65a.4.4,0,0,0,.4-.4,1.19,1.19,0,0,1,2.38,0,.4.4,0,0,0,.4.4H10Zm1.19,3.56H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79m0,2.38H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79m0,2.38H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79" transform="translate(-0.5 -0.5)"></path></svg>',
//       isShow: 1,
//       loader:null,
//       body_html: '<div class="custom-reward-main"></div>'
//     };
//   var obj2 = 
//       {
//         title: 'My NY Orders',
//         url:'https://ny.vervewine.com/account',
//         target:1,
//         badge: null,
//         icon: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19"><path d="M9.92,19.5a.4.4,0,0,1-.28-.12A.4.4,0,0,1,9.53,19l.56-2.8a.39.39,0,0,1,.11-.2l6.16-6.16a1.19,1.19,0,0,1,1.68,0L19.15,11a1.19,1.19,0,0,1,0,1.68L13,18.82a.39.39,0,0,1-.2.11l-2.8.56H9.92m.92-3-.42,2.1,2.1-.42,6.07-6.07a.4.4,0,0,0,0-.56l-1.12-1.12a.4.4,0,0,0-.56,0ZM12,2.87H10.79v-.4a.4.4,0,0,0-.4-.4H9.17a2,2,0,0,0-3.88,0H4.06a.4.4,0,0,0-.4.4v.4H2.48a2,2,0,0,0-2,2V15.15a2,2,0,0,0,2,2H8a.4.4,0,0,0,0-.79H2.48a1.19,1.19,0,0,1-1.19-1.19V4.85A1.19,1.19,0,0,1,2.48,3.67H3.67v.4A1.19,1.19,0,0,0,4.85,5.25H9.6a1.19,1.19,0,0,0,1.19-1.19v-.4H12a1.19,1.19,0,0,1,1.19,1.19V9.6a.4.4,0,1,0,.79,0V4.85a2,2,0,0,0-2-2M10,4.06a.4.4,0,0,1-.4.4H4.85a.4.4,0,0,1-.4-.4V2.87H5.65a.4.4,0,0,0,.4-.4,1.19,1.19,0,0,1,2.38,0,.4.4,0,0,0,.4.4H10Zm1.19,3.56H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79m0,2.38H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79m0,2.38H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79" transform="translate(-0.5 -0.5)"></path></svg>',
//         isShow: 1,
//         loader:null,
//         body_html: ''
//       };
//   var obj3 = 
//       {
//         title: 'My CHI Orders',
//         url:'https://chi.vervewine.com/account',
//         target:1,
//         badge: null,
//         icon: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19"><path d="M9.92,19.5a.4.4,0,0,1-.28-.12A.4.4,0,0,1,9.53,19l.56-2.8a.39.39,0,0,1,.11-.2l6.16-6.16a1.19,1.19,0,0,1,1.68,0L19.15,11a1.19,1.19,0,0,1,0,1.68L13,18.82a.39.39,0,0,1-.2.11l-2.8.56H9.92m.92-3-.42,2.1,2.1-.42,6.07-6.07a.4.4,0,0,0,0-.56l-1.12-1.12a.4.4,0,0,0-.56,0ZM12,2.87H10.79v-.4a.4.4,0,0,0-.4-.4H9.17a2,2,0,0,0-3.88,0H4.06a.4.4,0,0,0-.4.4v.4H2.48a2,2,0,0,0-2,2V15.15a2,2,0,0,0,2,2H8a.4.4,0,0,0,0-.79H2.48a1.19,1.19,0,0,1-1.19-1.19V4.85A1.19,1.19,0,0,1,2.48,3.67H3.67v.4A1.19,1.19,0,0,0,4.85,5.25H9.6a1.19,1.19,0,0,0,1.19-1.19v-.4H12a1.19,1.19,0,0,1,1.19,1.19V9.6a.4.4,0,1,0,.79,0V4.85a2,2,0,0,0-2-2M10,4.06a.4.4,0,0,1-.4.4H4.85a.4.4,0,0,1-.4-.4V2.87H5.65a.4.4,0,0,0,.4-.4,1.19,1.19,0,0,1,2.38,0,.4.4,0,0,0,.4.4H10Zm1.19,3.56H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79m0,2.38H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79m0,2.38H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79" transform="translate(-0.5 -0.5)"></path></svg>',
//         isShow: 1,
//         loader:null,
//         body_html: ''
//       };
//   settings.navs.splice(10, 0, obj);
//   settings.navs.splice(11, 0, obj2,obj3); //here index means position of navigation tab, element means content for tab.
//   //     if (Flits(window).width() < 992) {
//   //       var intervalTwo = setInterval(function(){

//   //         if(Flits('#flits_tab_rewardprogram .custom-reward-main').length){
//   //           Flits('#flits_tab_rewardprogram .custom-reward-main').remove();
//   //           clearInterval(intervalTwo);
//   //         }
//   //       },100);
//   //     }
//   setTimeout(function(){
//     Flits(".flits-menu-item a[href='https://ny.vervewine.com/account']").attr("href","https://ny.vervewine.com/account#order");
//     Flits(".flits-menu-item a[href='https://chi.vervewine.com/account']").attr("href","https://chi.vervewine.com/account#order");

//   },500);
// });

var interval = setInterval(function(){

  if(Flits('.flits-custom-reward-page .Rise__rewards-page').length){
    Flits.dispatchEvent("Flits:AccountPage:RewardsLoaded");
    clearInterval(interval);
  }

},1000);

Flits(document).on('Flits:AccountPage:RewardsLoaded', function(event){
  setTimeout(function(){
    var rewards_integrated_page = Flits(".flits-custom-reward-page").children();
    if (Flits(window).width() < 992) {
      Flits('.flits-custom-reward-page').insertAfter("#flits_mobile_tab_rewardprogram .custom-reward-main");
    }else{
      Flits('.flits-custom-reward-page').insertAfter("#flits_tab_rewardprogram .custom-reward-main");
    }
  }, 500);
});
  Flits(document).on('Flits:SocialLogin:Loaded', function(event){  
    setTimeout(function(){
      if (location.pathname == "/account/register"){
        Flits.setLocalStorage('flits_before_login_url','/pages/account-create');
      }
    }, 800);
  });

  Flits(window).load(function() {  
    if (location.pathname == "/account/register"){
      Flits.setLocalStorage('flits_before_login_url','/pages/account-create');
      if(Flits('input[name="checkout_url"]').length){
        Flits('input[name="checkout_url"]').val('/pages/account-create');
      }
      if(Flits('input[name="return_to"]').length){
        Flits('input[name="return_to"]').val('/pages/account-create');
      }
    }
    setTimeout(function(){
      if (location.pathname == "/account/register"){
        Flits.setLocalStorage('flits_before_login_url','/pages/account-create');
        if(Flits('input[name="checkout_url"]').length){
          Flits('input[name="checkout_url"]').val('/pages/account-create');
        }
        if(Flits('input[name="return_to"]').length){
          Flits('input[name="return_to"]').val('/pages/account-create');
        }
      }
    },1000);
    
  });
}(Flits));
